import { init } from './js/smaka-app';
import * as styles from './styles/smaka-main.scss';

export default {
  init,
  styles,
};
